export const API_TOKEN_SET = 'admin-login.API_TOKEN_SET'
export const EMAIL_SET = 'admin-login.EMAIL_SET'
export const PASSWORD_SET = 'admin-login.PASSWORD_SET'
export const LOADING_SET = 'admin-login.LOADING_SET'
export const ERROR_SET = 'admin-login.ERROR_SET'
